


























import { Component, Prop, Vue } from "@/shared/vuepack";
import AccountTypeSubheader from "@/employee/components/investments/drivewealth/AccountTypeSubheader.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { useDrivewealthWizardStore } from "@/shared/store/drivewealthWizard";
import { useDrivewealthStore } from "@/shared/store/drivewealth";
import * as Routes from "@/employee/route-names";
import CurrentHoldingsTable from "@/shared/components/investments/drivewealth/CurrentHoldingsTable.vue";
import DrivewealthNavigation from "@/shared/components/investments/drivewealth/DrivewealthNavigation.vue";
import { DrivewealthAccountManagementType } from "@/shared/types";

@Component({
  components: {
    DrivewealthNavigation,
    CurrentHoldingsTable,
    GenericLoadingSpinner,
    AccountTypeSubheader
  }
})
export default class CurrentHoldings extends Vue {
  @Prop({ required: false })
  username: string;

  @Prop({ required: false })
  partnerId: number;

  @Prop({ required: true })
  accountId: number;

  drivewealthStore = useDrivewealthStore();
  drivewealthWizardStore = useDrivewealthWizardStore();

  Routes = Routes;

  get isLoaded (): boolean {
    return this.drivewealthStore.accountSummaryV2Loaded(this.accountId);
  }

  get displayRetakeRtqButton (): boolean {
    const account = this.drivewealthStore.accountSummaryById(this.accountId);

    return account.accountManagementType === DrivewealthAccountManagementType.RiaManaged;
  }
}
